/**
 * Configuration flags for auth system debugging
 * Use these to disable specific features while testing
 */

export const authDebugConfig = {
  // Completely disable auth interceptor calls - SET TO TRUE TO STOP REFRESH LOOPS
  disableAuthInterceptor: true, // TEMPORARILY DISABLED TO PREVENT REFRESH LOOPS
  
  // Disable subscription monitoring
  disableSubscriptionMonitor: false,
  
  // Disable background auth checks
  disableBackgroundAuthCheck: true, // TEMPORARILY DISABLED TO PREVENT REFRESH LOOPS
  
  // Enable verbose logging
  enableVerboseLogging: true,
  
  // Minimum intervals (in milliseconds)
  minAuthCheckInterval: 60000, // 1 minute minimum
  minSubscriptionCheckInterval: 300000, // 5 minutes minimum
}

// Helper function to check if auth interceptor should run
export const shouldRunAuthInterceptor = (): boolean => {
  return !authDebugConfig.disableAuthInterceptor
}

// Helper function to check if subscription monitor should run
export const shouldRunSubscriptionMonitor = (): boolean => {
  return !authDebugConfig.disableSubscriptionMonitor
}

// Helper function to check if background auth check should run
export const shouldRunBackgroundAuthCheck = (): boolean => {
  return !authDebugConfig.disableBackgroundAuthCheck
}

// Helper function for verbose logging
export const logAuthDebug = (message: string, ...args: any[]): void => {
  if (authDebugConfig.enableVerboseLogging) {
    console.log(`🔍 AUTH DEBUG: ${message}`, ...args)
  }
}

export default authDebugConfig
